import script from "./email-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-templates-configuration-modal.vue?vue&type=style&index=0&id=12642b52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12642b52"]])

export default __exports__